export const FOOTER_EXPERTISES = [
  "Production audiovisuelle",
  "Diffusion & publicité",
  "Voix off & podcast",
  "Communication événementielle",
  "Brand content & storytelling",
] as const;

export const FOOTER_LEGAL_LINKS = [
  { to: "/mentions-legales", label: "Mentions légales" },
  { to: "/politique-confidentialite", label: "Politique de confidentialité" },
] as const;
